<div class="toolkit toolkit-page">
  <app-header [forceLightBackground]="true"></app-header>

  <div class="toolkit-page--content">
    <app-asset-header [config]="headerConfig"></app-asset-header>

    <div class="toolkit-page--main">
      <div class="toolkit-page--container">
        <!-- Filter Sidebar (Desktop) -->
        <aside class="toolkit-page--sidebar">
          <app-asset-filter
            [config]="filterConfig"
            [searchPlaceholder]="filterSearchPlaceholder"
            [isLoggedIn]="true"
            (filterChange)="onFilterChange($event)"
            (resetFilters)="onResetFilters()"
          ></app-asset-filter>
        </aside>

        <!-- Grid Section -->
        <main class="toolkit-page--grid">
          <!-- Search and View Controls -->
          <div class="toolkit__controls">
            <div class="toolkit__search-wrapper">
              <div class="toolkit__search">
                <input
                  type="text"
                  class="toolkit__search-input"
                  placeholder="Search for toolsets"
                  [(ngModel)]="searchQuery"
                  (input)="onSearchChange()"
                  aria-label="Search toolsets"
                />
                <img src="/filters/search-normal.svg" alt="" class="toolkit__search-icon" />
              </div>
              <button
                type="button"
                class="toolkit__mobile-filter-btn"
                (click)="openMobileFilter()"
                aria-label="Open filters"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M22 3H2L10 12.46V19L14 21V12.46L22 3Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
            <div class="toolkit__view-toggle">
              <button
                type="button"
                class="toolkit__view-btn"
                [class.active]="viewMode === 'grid'"
                (click)="onViewModeChange('grid')"
                aria-label="Grid view"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <rect x="3" y="3" width="7" height="7" stroke="currentColor" stroke-width="2"/>
                  <rect x="14" y="3" width="7" height="7" stroke="currentColor" stroke-width="2"/>
                  <rect x="3" y="14" width="7" height="7" stroke="currentColor" stroke-width="2"/>
                  <rect x="14" y="14" width="7" height="7" stroke="currentColor" stroke-width="2"/>
                </svg>
                <span class="toolkit__view-label">Grid</span>
              </button>
              <button
                type="button"
                class="toolkit__view-btn"
                [class.active]="viewMode === 'list'"
                (click)="onViewModeChange('list')"
                aria-label="List view"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M8 6H21M8 12H21M8 18H21M3 6H3.01M3 12H3.01M3 18H3.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span class="toolkit__view-label">List</span>
              </button>
            </div>
          </div>

          <!-- Empty State -->
          <div class="toolkit__empty-state" *ngIf="filteredCards.length === 0">
            <p class="toolkit__empty-message">No toolsets match your filters. Try adjusting your search or filters.</p>
          </div>

          <!-- Cards Grid / List -->
          <div
            class="toolkit__grid"
            [class.toolkit__grid--list]="viewMode === 'list'"
            *ngIf="filteredCards.length > 0"
          >
            <article
              *ngFor="let card of displayedCards"
              class="toolkit-card"
            >
              <div class="toolkit-card__body">
                <h3 class="toolkit-card__title">{{ card.title }}</h3>
                <p class="toolkit-card__short-desc">{{ card.shortdescription }}</p>
                <div class="toolkit-card__bottom-row">
                  <span class="toolkit-card__badge toolkit-card__badge--category">{{ card.category }}</span>
                  <a
                    [href]="card.githubLink"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="toolkit-card__link"
                    [attr.aria-label]="'Learn more about ' + card.title"
                  >
                    <svg class="toolkit-card__link-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </a>
                </div>
              </div>
            </article>
          </div>

          <p-paginator
            *ngIf="shouldShowPagination"
            [rows]="pageSize"
            [totalRecords]="filteredCards.length"
            [first]="(currentPage - 1) * pageSize"
            [rowsPerPageOptions]="[]"
            (onPageChange)="onPageChange($event)"
            styleClass="table--paginator"
          ></p-paginator>
        </main>
      </div>
    </div>
  </div>

  <app-footer></app-footer>

  <!-- Mobile Filter Overlay -->
  <div
    class="toolkit-page--mobile-filter-overlay"
    [class.active]="isMobileFilterOpen"
    (click)="closeMobileFilter()"
  ></div>
  <div class="toolkit-page--mobile-filter-modal" [class.active]="isMobileFilterOpen">
    <div class="toolkit-page--mobile-filter-header">
      <h2 class="toolkit-page--mobile-filter-title">Filters</h2>
      <button
        type="button"
        class="toolkit-page--mobile-filter-close"
        (click)="closeMobileFilter()"
        aria-label="Close filters"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
    <div class="toolkit-page--mobile-filter-content">
      <app-asset-filter
        [config]="filterConfig"
        [searchPlaceholder]="filterSearchPlaceholder"
        [isLoggedIn]="true"
        (filterChange)="onFilterChange($event)"
        (resetFilters)="onResetFilters()"
      ></app-asset-filter>
    </div>
    <div class="toolkit-page--mobile-filter-footer">
      <button
        type="button"
        class="toolkit-page--mobile-filter-reset"
        (click)="onResetFilters()"
        *ngIf="filterConfig.activeFilterCount > 0"
      >
        Reset
      </button>
      <button
        type="button"
        class="toolkit-page--mobile-filter-apply"
        (click)="closeMobileFilter()"
      >
        Apply Filter ({{ filterConfig.activeFilterCount }})
      </button>
    </div>
  </div>
</div>
